// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2S2Ll","footer__link":"footer-module--footer__link--35ELt"};